module.exports = __webpack_public_path__ + "static/media/Car-Wash-Checklist.492c08ce.svg";